(() => {
  function init(scope) {
    scope.querySelectorAll('[data-sonolya-reviews]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = Array.from(root.querySelectorAll('[data-review]'));
      const size = Number(root.dataset.pageSize) || 6;
      const total = Math.ceil(cards.length / size);
      const pagination = root.querySelector('[data-review-pagination]');
      const pages = root.querySelector('[data-review-pages]');
      const prev = root.querySelector('[data-review-prev]');
      const next = root.querySelector('[data-review-next]');
      const status = root.querySelector('[data-review-status]');
      let current = 1;
      const buttons = Array.from({length: total}, (_, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(i + 1);
        button.setAttribute('aria-label', `${root.dataset.pageLabel} ${i + 1}`);
        button.addEventListener('click', () => show(i + 1, true));
        pages.append(button);
        return button;
      });
      function show(page, scroll) {
        current = Math.max(1, Math.min(total, page));
        cards.forEach((card, i) => { card.hidden = i < (current - 1) * size || i >= current * size; });
        buttons.forEach((button, i) => {
          if (i + 1 === current) button.setAttribute('aria-current', 'page');
          else button.removeAttribute('aria-current');
        });
        prev.disabled = current === 1;
        next.disabled = current === total;
        status.textContent = `${root.dataset.pageLabel} ${current} ${root.dataset.ofLabel} ${total}`;
        if (scroll) {
          buttons[current - 1].focus({preventScroll: true});
          root.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        }
      }
      prev.addEventListener('click', () => show(current - 1, true));
      next.addEventListener('click', () => show(current + 1, true));
      pagination.hidden = total <= 1;
      show(1, false);
    });
  }
  init(document);
  if (!window.sonolyaReviewsListener) {
    document.addEventListener('shopify:section:load', event => init(event.target));
    window.sonolyaReviewsListener = true;
  }
})();
